import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-progress',
	templateUrl: './progress.component.html',
	styleUrls: ['./progress.component.css']
})

export class ProgressComponent {
	visible:true;
}



// WEBPACK FOOTER //
// ./src/app/components/utility/loader/progress.component.ts